module.exports = __webpack_public_path__ + "img/kv.9ef0ce36.png";